import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils/api/api-client";
import { NotificationsApi } from "@/openapi/generated";

const NOTIFICATIONS_UNREAD_COUNT_STALE_TIME_MS = 30_000;

/** Server prefetch for the notification bell badge (count-only endpoint). */
export async function prefetchNotificationsUnreadCountGet(
  queryClient: QueryClient,
  userId: number,
  accessToken: string,
) {
  const service = createAuthenticatedApi(NotificationsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.NotificationsUnreadCount, userId],
    queryFn: () =>
      service.apiNotificationsUserIdUnreadCountGet({
        userId,
      }),
    staleTime: NOTIFICATIONS_UNREAD_COUNT_STALE_TIME_MS,
  });

  return queryClient;
}
